import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFilterPipe } from './field-filter.pipe';
import { MomentPipe } from './moment.pipe';
import { NumbroPipe } from './numbro.pipe';
import { SafePipe } from './safe.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FieldFilterPipe, MomentPipe, NumbroPipe,SafePipe],
  exports: [FieldFilterPipe, MomentPipe, NumbroPipe,SafePipe]
})
export class PipesModule { }
